<template>
    <menu-layout :loading="loading">
        <row>
            <col2>
                <page-menu
                    :name="$t('superadmin_menu.name')"
                    :title="$t('superadmin_menu.title')"
                    base-route="/superadmin"
                    :items="[
                      {'name': $t('superadmin_menu.slow_queries'), 'route': '/superadmin/slow-queries'},
                      {'name': $t('superadmin_menu.slow_routes'), 'route': '/superadmin/slow-routes'},
                    ]"
                ></page-menu>
            </col2>
            <col12 style="max-width: 1400px;">
                <slot></slot>
            </col12>
        </row>
    </menu-layout>
</template>

<script>
import Row from "@/components/layout/Row";
import Col2 from "@/components/layout/Col2";
import PageMenu from "@/components/layout/PageMenu";
import Col12 from "@/components/layout/Col12";
import MenuLayout from "@/components/layout/MenuLayout";

export default {
  name: "SuperAdminMenuLayout",
  components: {MenuLayout, Col12, PageMenu, Col2, Row},
  data() {
    return {
      loading: false,
    }
  }
}
</script>
